import { apiRequest } from "../../../infrastructure/backendService";
import {CommonOutlinedButton } from "../../common/StyledComponents/StyledFields";
import { useEffect, useRef, useState } from "react";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import apiPath from "../../../config/apiPaths.json";

const VendorReport = ({ sendDataToParent, getReportData,getReqBodyAndResData }:any) => {
const [loading, setLoading] = useState(false);
const [pageNumber, setPageNumber] = useState<number>(1);
const [totalRecords, setTotalRecords] = useState<number>(0);
const [pageSize, setPageSize] = useState<number>(250);

useEffect(()=>{
    if(totalRecords){
        setTotalRecords(totalRecords)
    }
},[setTotalRecords])

const handleSubmit = async () => {
    setLoading(true);
    apiRequest({
        method: "GET",
        endpoint: `${apiPath.vendorReport}/VENDOR_REPORTS`,
        includeToken:true,
        params: {
            pageNumber: pageNumber - 1,
            pageSize: pageSize,
            }
        })
        .then((res) => {
        setLoading(false);
        sendDataToParent(true,{reportName:'Vendor Report',
          totalRecords:res.data.totalElements,
            pageSize:pageSize});
        getReportData(res.data.data);
        })
        .catch((err) => {
        setLoading(false);
        })
}
    
    return (
      <CommonOutlinedButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleSubmit}
        disabled={loading}
        id="submit"
      >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
      </CommonOutlinedButton>
    );
}
export default VendorReport;